<template>
  <div>
    <NantongDialog v-if="isNanTong" v-model:show="showTip" @right-click="downLoadTap" @left-click="showTip = false"
      title="观看次数已达上限" subTitle="使用APP体验 无限制观看" left-btn-text="明日登录" right-btn-text="立即下载" />

    <van-dialog v-else v-model:show="showTip" :show-confirm-button="false" width="280px">
      <div class="relative overLimitTip flex flex-col items-center rounded-[10px] h-[250px]">
        <div class="w-full h-full bg1 bg-black absolute -z-[1] rounded-[10px] overflow-hidden"></div>
        <img src="/images/overLimit.png" class="w-[94px] h-[94px] absolute left-[50%] -top-[40px] -translate-x-[50%]" />
        <div class="text-center font-normal pt-[70px] word">
          <div class="text-[24px]">观影次数已达上限</div>
          <div class="mt-[10px]">
            <span class="text-[20px]">使用<span class="text-[#FFCB58]">APP</span>体验</span>
            <div class="text-[18px]">无限制观看</div>
          </div>
        </div>
        <div class="flex justify-center items-center mt-[14px]">
          <div @click="downLoadTap" class="btn now">立即下载</div>
          <div class="btn ml-[30px] tomorrow" @click="showTip = false">明日观看</div>
        </div>
        <div class="action-con absolute -bottom-[30px] left-[50%] -translate-x-[50%]" @click="showTip = false">
          <van-icon class="close-icon" name="close" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script setup lang="ts">
import { openUrl } from '~/utils/openUrl';

const globalStore = useGlobalStore()
const { appData, showTip, isNanTong }: any = storeToRefs(globalStore)
const downloadData = computed(() => appData.value?.externalLink?.[0])
//跳转下载页
const downLoadTap = () => {
  trackEvent({ type: 'clklog', category: 'appDownload' })
  if (process.client) {
    if (downloadData?.value?.appDownloadUrl) {
      let urlStr = decodeURIComponent(downloadData?.value?.appDownloadUrl).replace(/amp;/g, '')
      openUrl(urlStr)
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.van-dialog) {
  overflow: unset;
  border-radius: 10px !important;
}

// .van-theme-light {

// }

// .van-theme-dark {
.overLimitTip {
  .bg1 {
    border-radius: 10px;
    background: linear-gradient(180deg, #4B3402 0%, #000 100%);
    backdrop-filter: blur(2px);
  }

  .word {
    color: white;
  }

  .btn {
    @apply border border-[#CECDCD] rounded-[10px] px-[14px] py-[4px] overflow-hidden;

    &.now {
      color: #CECDCD;
    }

    &.tomorrow {
      color: #000;
      background-color: #FFCB58;
    }
  }

}

.action-con {
  display: flex;
  justify-content: center;
  align-items: center;

  :deep(.van-icon-close:before) {
    font-size: 24px;
  }
}

.nantongOverLimitTip {
  border-radius: 14px;
  background: linear-gradient(170deg, #FFF 6.3%, #D4D4E8 97.94%);
  overflow: hidden;
}
</style>
